// Hotfix P1 orphan cleanup · Family C · Community cluster nav extension.
// -----------------------------------------------------------------------------
// Spot-check componenti ha confermato 10 route Events/Rooms/Community
// FUNCTIONAL (file size 83-261 righe, no placeholder). Verdict: KEEP ALL.
//
// Fix: aggiunta cluster "Community" al V12_USER_NAV_MINIMAL (post-discovery).
// Deep-link (`/*/create`, `/*/:id`) restano reachable via navigation interna
// delle pagine · solo i 3 top-level entry nel sidebar.
//
// Chain: v12_user_nav.js applica prima applyUserDiscoveryExtensions (già wired)
// e poi applyUserCommunityExtensions su quel risultato · ordine deterministico.

const _USER_ROLES = ["user", "admin", "super_admin"];

export const V12_USER_NAV_COMMUNITY_EXTENSIONS = {
    newGroups: [
        {
            insertAfter: "discovery",
            group: {
                id: "community",
                label: "Community",
                labelKey: "nav.cluster.community",
                icon: "Users",
                allowFor: _USER_ROLES,
                items: [
                    {
                        id: "min-community",
                        label: "Community",
                        to: "/community",
                        implemented: true,
                        icon: "MessageSquare",
                        keywords: ["community", "feed", "posts", "social"],
                    },
                    {
                        id: "min-community-events",
                        label: "Events",
                        to: "/events",
                        implemented: true,
                        icon: "Calendar",
                        keywords: ["events", "live", "calendar", "webinar"],
                    },
                    {
                        id: "min-community-rooms",
                        label: "Rooms",
                        to: "/rooms",
                        implemented: true,
                        icon: "Mic",
                        keywords: ["rooms", "audio", "video", "live"],
                    },
                ],
            },
        },
    ],
};

/**
 * Merge Community cluster · pure function · stesso pattern di
 * applyUserDiscoveryExtensions. Idempotente: se cluster `community` già
 * presente → no-op (previene duplicati durante hot-reload).
 */
export function applyUserCommunityExtensions(baseGroups) {
    if (baseGroups.some((g) => g.id === "community")) return baseGroups;
    const out = [];
    const pending = [...V12_USER_NAV_COMMUNITY_EXTENSIONS.newGroups];
    for (const g of baseGroups) {
        out.push(g);
        for (let i = pending.length - 1; i >= 0; i--) {
            if (pending[i].insertAfter === g.id) {
                out.push(pending[i].group);
                pending.splice(i, 1);
            }
        }
    }
    if (pending.length > 0) {
        // eslint-disable-next-line no-console
        console.warn(
            "[V12 user nav] community extensions con insertAfter non trovato:",
            pending.map((p) => p.group.id),
        );
        for (const p of pending) out.push(p.group);
    }
    return out;
}
